import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';

export default function ExplorarPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ProductsSection />
      <Footer />
    </div>
  );
}
